var _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrderPlaced(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 94,
    viewBox: "0 0 108 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter0_f_8040_11102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 32C32 24.268 38.268 18 46 18H62.0026C69.7346 18 76.0026 24.268 76.0026 32V48.0026C76.0026 55.7346 69.7346 62.0026 62.0026 62.0026H46C38.268 62.0026 32 55.7346 32 48.0026V32Z",
    fill: "url(#paint0_linear_8040_11102)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_8040_11102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 32C32 24.268 38.268 18 46 18H62.0026C69.7346 18 76.0026 24.268 76.0026 32V48.0026C76.0026 55.7346 69.7346 62.0026 62.0026 62.0026H46C38.268 62.0026 32 55.7346 32 48.0026V32Z",
    fill: "url(#paint1_linear_8040_11102)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8040_11102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.0006 50.0012C59.5238 50.0012 64.0012 45.5238 64.0012 40.0006C64.0012 34.4774 59.5238 30 54.0006 30C48.4774 30 44 34.4774 44 40.0006C44 45.5238 48.4774 50.0012 54.0006 50.0012Z",
    stroke: "white",
    strokeWidth: 2.50015,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 40L53 42L57 38",
    stroke: "white",
    strokeWidth: 2.50015,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dd_8040_11102)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-1_8040_11102",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66 22.0004C66 18.6865 68.6864 16 72.0003 16C75.3142 16 78.0007 18.6865 78.0007 22.0004C78.0007 25.3143 75.3142 28.0007 72.0003 28.0007C68.6864 28.0007 66 25.3143 66 22.0004Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M66 22.0004C66 18.6865 68.6864 16 72.0003 16C75.3142 16 78.0007 18.6865 78.0007 22.0004C78.0007 25.3143 75.3142 28.0007 72.0003 28.0007C68.6864 28.0007 66 25.3143 66 22.0004Z",
    fill: "url(#paint2_linear_8040_11102)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66 22.0004M78.0007 22.0004M78.0007 22.0004M66 22.0004M72.0003 16M78.0007 22.0004M72.0003 28.0007M66 22.0004M72.0003 28.0007V26.0007C69.791 26.0007 68 24.2097 68 22.0004H66H64C64 26.4188 67.5819 30.0007 72.0003 30.0007V28.0007ZM78.0007 22.0004H76.0007C76.0007 24.2097 74.2097 26.0007 72.0003 26.0007V28.0007V30.0007C76.4188 30.0007 80.0007 26.4188 80.0007 22.0004H78.0007ZM72.0003 16V18C74.2097 18 76.0007 19.791 76.0007 22.0004H78.0007H80.0007C80.0007 17.5819 76.4188 14 72.0003 14V16ZM72.0003 16V14C67.5819 14 64 17.5819 64 22.0004H66H68C68 19.791 69.791 18 72.0003 18V16Z",
    fill: "white",
    mask: "url(#path-5-inside-1_8040_11102)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_8040_11102",
    x: 0,
    y: -14,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16,
    result: "effect1_foregroundBlur_8040_11102"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_8040_11102",
    x: 20,
    y: 16,
    width: 68,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_8040_11102"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8040_11102"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_8040_11102"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_8040_11102",
    result: "effect2_dropShadow_8040_11102"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_8040_11102",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dd_8040_11102",
    x: 54,
    y: 14,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_8040_11102"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8040_11102"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_8040_11102"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_8040_11102",
    result: "effect2_dropShadow_8040_11102"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_8040_11102",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8040_11102",
    x1: 32,
    y1: 18,
    x2: 76.0026,
    y2: 62.0026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BC7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009689"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8040_11102",
    x1: 32,
    y1: 18,
    x2: 76.0026,
    y2: 62.0026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BC7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009689"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8040_11102",
    x1: 66,
    y1: 16,
    x2: 78.0007,
    y2: 28.0007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BC7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009689"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8040_11102"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.0015,
    height: 24.0014,
    fill: "white",
    transform: "translate(42 28)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderPlaced);
export default __webpack_public_path__ + "static/media/Order Placed.c6a5a97d7fbc9ac92ecc765e7de1129f.svg";
export { ForwardRef as ReactComponent };